import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  HostBinding,
  Input
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-tin-signatory-input',
  templateUrl: './tin-signatory-input.component.html',
  styles: [
    `
      :host {
        display: inline-block;
        max-width: 100%;
      }
      :host(.tin-signatory-input--full-width) {
        display: block;
        width: 100%;
      }
      input {
        width: 180px;
        max-width: 100%;
        box-sizing: border-box;
      }
      :host(.tin-signatory-input--full-width) input {
        width: 100% !important;
      }
    `
  ],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TINSignatoryInputComponent),
      multi: true
    }
  ]
})
export class TINSignatoryInputComponent implements ControlValueAccessor {
  /** When true, the control spans the full width of its parent (e.g. grid/flex column). */
  @Input() fullWidth = false;

  @HostBinding('class.tin-signatory-input--full-width')
  get hostFullWidthClass(): boolean {
    return this.fullWidth;
  }

  @Input() value: any;
  @Input() disabled = false;
  @Input() maxLength: string | number | null = null;
  @Input() borderless = false;
  @Input() ignoreZero = false;
  @Input() allowEdit = true;

  get readonly() {
    if (this.disabled || !this.allowEdit) {
      return true;
    }
    return false;
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: number): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    if (val) this.value = formatTIN(val);
    else this.value = '';
    this.onChange(val);
    this.cdr.markForCheck();
  }

  onKeydown(event: any) {
    const key = `${event.key}`;
    if (key.length !== 1) return;

    const allow = key >= '0' && key <= '9';
    if (!allow) {
      event.preventDefault();
    }
  }

  onClick(e: any) {
    if (!window.getSelection()?.toString()) {
      e.select();
    }
  }
}

export function formatTIN(input: string) {
  let result = '';

  let digitCount = 0;
  for (let c of input) {
    if (c >= '0' && c <= '9') {
      digitCount++;
      result += c;
      if (digitCount === 13) return result;
      else if (digitCount <= 10 && digitCount % 3 === 0) {
        result += '-';
      }
    }
  }
  return result;
}
